import React from "react";
import {WorkflowsContext, WindowContext} from '@web/hooks/context';
import {Col, Row} from 'antd';
import PropTypes from 'prop-types';
import {AddActionButton} from './AddActionButton';

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.number,
  // app: PropTypes.object,
}

function Wrapper(props) {
  const [isMobile] = React.useContext(WindowContext);
  const wtx = React.useContext(WorkflowsContext);
  // console.log("Wrapper:wtx:", wtx.workflow);

  return <Row className="w-full relative bgb" style={{paddingTop: "20px", paddingBottom: "12px"}}>
    <Col xs={0} sm={0} md={0} lg={0} xl={0} xxl={0} />
    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className="overscroll-contain">
      <div
        className={`splash-card-wrapper space space-col space center-y space-center-x${isMobile ? " splash-card-wrapper-mobile" : " center"}`}
        style={{
          padding: "0 20px 20px 20px",
          width: "100%",
        }}
      >
        {props.children}
        {wtx.workflow?.name &&
          // wtx.workflow?.description &&
          // wtx.workflow?.access &&
          <AddActionButton />}
      </div>
    </Col>
  </Row>
}

export default Wrapper;
